import axios from 'axios'
import vm from '../main'
import {Message} from 'element-ui'
import route from '../router/index'

const request = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? 'http://api.bioleaper.com' : 'http://api.bioleaper.com',
  // baseURL: process.env.NODE_ENV === 'development' ? 'http://api.bioleaper.com.cn:6681/' : 'http://api.bioleaper.com.cn:6681/',
  timeout: 30000
})

request.interceptors.request.use(function (config) {
  let token = localStorage.getItem('token')
  if (token) {
    config.headers['access-token'] = token;
  }
   return config
}, function (error) {
  return Promise.reject(error)
})

//响应器拦截
request.interceptors.response.use(function (res) {
  if(res.config.url == '/v1/district'){}else{
    if ( res.data.status === -1 ) {
      if(localStorage.getItem('token' || 'Flag')){
        localStorage.removeItem('Flag')
        localStorage.removeItem('token')
        route.go(0)
        Message.closeAll()
        Message.error('您未登录请先登录')
        sessionStorage.removeItem('value')
      }else{
        Message.closeAll()
        Message.error('您未登录请先登录')
        sessionStorage.removeItem('value')
      }
    } 
  }
  return res.data;
}, function (error) {
  const res = error.res
  return Promise.reject(error)
})

export default {
  ...request,
  get (url, params) {
    return request.get(url, { params })
  }
}
